import { useContext } from 'react'
import { SearchContext } from './search-context'
import { Cancel } from '../../../atoms/icons/essentials'
import { iconSizeOptions } from '../../../atoms/icons/icons-sizes'

const SearchClearButton = ({ ...props }) => {
  const { showClearButton, isOpenInput, handleClear } =
    useContext(SearchContext)

  if (!showClearButton) {
    return null
  }

  return (
    <Cancel
      size={iconSizeOptions['ICON-XS']}
      onClick={handleClear}
      style={{
        cursor: 'pointer',
        display: isOpenInput ? 'block' : 'none'
      }}
      {...props}
    />
  )
}

export default SearchClearButton
